/* global $ */
import { resetElemsOnResize } from './cegep.resize'

const smallSize = 700
const mediumSize = 982

bindEscapeKey()

// Append hidden menus in complete main nav
const $hiddenMenus = $('#hidden-menus-holder').html()
$('#main-nav').after($hiddenMenus)
$('#hidden-menus-holder').remove()

// Show sub level navs
$('.js-open-main-nav').click(function () {
  openMainNav()
  return false
})

$('.js-show-level-2').click(function () {
  let theme = $(this).parent().attr('data-theme')
  const spaceIndex = theme.indexOf(' ')

  if (spaceIndex !== -1) {
    theme = theme.substring(0, spaceIndex)
  }

  if ($(window).width() >= mediumSize) {
    showLevel2($('.international-hidden-menu--' + theme), '.international-hidden--menu')

    closeAllFlyouts()

    const $activeMenu = this

    $('.js-show-level-2').each(function (e, elem) {
      if ($activeMenu === elem && $(this).find('.icon__chevron--down').length) {
        $(this).find('.icon__chevron--down').addClass('icon__close')
        $(this).find('.icon__chevron--down').removeClass('icon__chevron--down')
        $(this).closest('.main-nav__elem').addClass('active')
      } else {
        $(this).find('.icon__close').addClass('icon__chevron--down')
        $(this).find('.icon__close').removeClass('icon__close')
        $(this).closest('.main-nav__elem').removeClass('active')
      }
    })
  } else {
    showLevel2($('.hidden-menu--' + theme), '.hidden-menu')
  }

  return false
})

// Show sub meta nav
$('.with-submenu').click(function (e) {
  e.preventDefault()
  const buttonHtml = $(this).html()
  $('.header__sub-meta-nav').each(function () {
    if ($(this).parent().find('a:first').html() !== buttonHtml && $(this).css('display') !== 'none') {
      $(this).parent().find('a:first').removeClass('submenu-opened')
      $(this).hide()
    }
  })
  if ($(this).parent().find('.header__sub-meta-nav').css('display') === 'none') {
    $(this).addClass('submenu-opened')
    if ($(window).width() >= smallSize && $(window).width() < mediumSize && $('.logo .show-for-large-up').css('display') === 'none') {
      $('.logo').hide()
    }
    $(this).parent().find('.header__sub-meta-nav').fadeIn(300)
  } else {
    $(this).removeClass('submenu-opened')
    $(this).parent().find('.header__sub-meta-nav').fadeOut(300)
    setTimeout(function () {
      $('.logo').show()
    }, 150)
  }

  return false
})

// Menu does not close when it is clicked
$('.hidden-menu').click(function (e) {
  e.stopPropagation()
})

$('.hidden-menu__level-2 .js-back-menu-link').click(function () {
  goBackMenu($(this), 2)
  return false
})

function openMainNav () {
  const $navButton = $('.js-open-main-nav')
  const $mainNav = $('.main-nav')

  $('body').off('click')
  $navButton.off('click')
  $navButton.addClass('js-close-main-nav')

  if (!$('.active2').length) {
    $mainNav.css('left', -$(window).width())
    $mainNav.show()
    $mainNav.animate({
      left: 0
    }, 300)
  }

  if ($('#hidden-menus').find('.active-panel').length) {
    $('#hidden-menus')
      .find('.active-panel')
      .each(function () {
        showLevel2($(this).closest('.hidden-menu'), '.hidden-menu')
      })
  } else if ($('#hidden-menus').find('.active2').length) {
    showLevel2($($('#hidden-menus').find('.active2').closest('.hidden-menu', '.hidden-menu')))
  }

  $navButton.click(function () {
    closeMainNav()
    return false
  })
}

export function closeMainNav () {
  const $navButton = $('.js-open-main-nav')
  const $mainNav = $('.main-nav')

  $navButton.unbind('click')
  $navButton.removeClass('js-close-main-nav')

  $('.hidden-menu').each(function () {
    if ($(this).css('display') !== 'none') {
      if ($(window).width() >= mediumSize) {
        $(this).slideToggle(300, 'easeOutQuart')
      } else {
        $(this).animate({
          left: '100%'
        }, 300, 'easeOutQuart', $(this).hide())
      }

      $(this).css('display', 'none')
    }
  })

  $mainNav.animate({
    left: -$(window).width()
  }, 300, function () {
    $mainNav.hide()
  })

  $navButton.click(function () {
    openMainNav()
    return false
  })
}

function goBackMenu ($backBtn, level) {
  const $menu = $backBtn.parent().parent().parent()
  let $elementToClose = $menu
  const $mainNav = $('.main-nav')
  let leftClose = '0'
  const closeTimer = 0
  let themeName = ''
  let $focusTarget = null

  $mainNav.css('left', 0)
  $mainNav.show()

  // Change variables based on level
  if (level === 2) {
    $elementToClose = $menu.closest('.hidden-menu')
    themeName = $menu.closest('.hidden-menu').attr('id')
    $focusTarget = $('.main-nav__elem[data-theme="' + themeName + '"] .js-show-level-2')
  }

  // Change the leftClose value for small size, regardless of level
  if ($(window).width() < mediumSize) {
    leftClose = '100%'
  }

  // if level2 and >= mediumWidth, use same pattern as when using the close icon
  if (level === 2 && $(window).width() >= mediumSize) {
    showLevel2($('.hidden-menu--' + themeName))

    $('.main-nav .icon__close').each(function () {
      $(this).addClass('icon__chevron--down')
      $(this).removeClass('icon__close')
      $(this).closest('.main-nav__elem').removeClass('active')
    })
  } else if (level === 2) {
    setTimeout(function () {
      $menu.removeClass('active-panel')
      $elementToClose.animate({ left: leftClose }, 300, function () {
        $elementToClose.hide()
      })
    }, closeTimer)
  } else {
    setTimeout(function () {
      $menu.removeClass('active-panel')
      const $toClose = $elementToClose.parent().parent().parent()
      $toClose.animate({ left: leftClose }, 300, function () {
        $(this).hide()
      })
    }, closeTimer)
  }

  // set focus manually to previous button
  $focusTarget[0].focus()
}

function showLevel2 ($menuToShow, $selector) {
  let timer = 0
  const timer2 = 0

  $('body').off('click')

  setTimeout(function () {
    // Close any open level 2 menu
    $($selector).each(function () {
      if ($(this).css('display') !== 'none') {
        if ($(window).width() >= mediumSize) {
          $(this).slideToggle(300, 'easeOutQuart')
        } else {
          $(this).animate({
            left: '100%'
          }, 300, 'easeOutQuart', $(this).hide())
        }
        timer = 500
      } else if ($(this).css('display') !== 'none' && $(this).attr('id') === $menuToShow.attr('id')) {
        $('.close-level-2-menu').removeClass('close-level-2-menu')
      }
    })

    setTimeout(function () {
      // Open the desired menu
      if ($(window).width() >= mediumSize) {
        if ($menuToShow.css('display') === 'none') {
          $menuToShow.slideDown(300, 'easeInQuart')
          $menuToShow[0].setAttribute('tabindex', '-1')
          $menuToShow[0].focus()
        } else {
          $menuToShow.slideUp(300, 'easeInQuart')
        }
      } else {
        $menuToShow.css('left', '100%')
        $menuToShow.show()
        $menuToShow.animate({
          left: '0%'
        }, 300, 'easeInQuart')
        $menuToShow.find('.js-back-menu-link button')[0].focus()
      }
    }, timer)
  }, timer2)

  // Close menu on page click
  $('body').click(function () {
    if ($(window).width() < mediumSize) {
      closeMainNav()
    } else {
      closeAllFlyouts()
    }

    $($selector).each(function () {
      if ($(this).css('display') !== 'none' && $(this).attr('id') === $menuToShow.attr('id')) {
        if ($(window).width() >= smallSize) {
          $(this).slideToggle(300, 'easeOutQuart')
        } else {
          $(this).animate({
            left: '100%'
          }, 300, 'easeOutQuart', $(this).hide())
        }
        timer = 500
      }
    })
    $('.icon__close').each(function () {
      $(this).addClass('icon__chevron--down')
      $(this).removeClass('icon__close')
      $(this).closest('.main-nav__elem').removeClass('active')
    })
    $('.js-show-level-2').each(function () {
      $(this).children().find('.icon__close').addClass('icon__chevron--down')
      $(this).children().find('.icon__chevron--down').removeClass('icon__close')
      $(this).closest('.main-nav__elem').addClass('active')
    })
  })
}

function bindEscapeKey () {
  const mediumSize = 1000

  $(document).keyup(function (e) {
    if (e.keyCode === 27) {
      if ($(window).width() < mediumSize) {
        closeMainNav()
        if ($('#main-nav').css('display') === 'block') {
          $('.js-open-main-nav')[0].focus()
        }
      } else {
        $('.hidden-menu').each(function () {
          if ($(this).css('display') === 'block') {
            const themeName = $(this).attr('id')
            const $focusTarget = $('.main-nav__elem[data-theme="' + themeName + '"] .js-show-level-2')
            $focusTarget[0].focus()
            return false
          }
        })
        resetElemsOnResize()
      }
    }
  })
}

function closeAllFlyouts () {
  $('.international-hidden-menu').each(function (i) {
    $(this).slideUp(300, 'easeInQuart')
  })
}

// Fermer le menu de page lors du clic sur un bouton
const landingNavBtn = document.querySelectorAll('.page-nav .main-nav__top-level-link')
landingNavBtn.forEach(btn => btn.addEventListener('click', closeMainNav))
